import React, { useState } from "react";
import { useMutation } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import { BOOST_DATA_QUERY } from "components/Pages/CustomerSupport/BoostSubscriptionManager/query";

export const PAUSE_BOOST_SUBSCRIPTION = gql`
  mutation PauseBoostSubscription($email: String!, $duration: Int!) {
    pauseBoostSubscription(email: $email, duration: $duration) {
      status
    }
  }
`;

/**
 *
 * @param {Object} props
 * @param {number} props.duration - The duration for which the subscription will be paused, in days.
 * @param {boolean} props.loading - Indicates whether the pause operation is in progress.
 * @param {boolean} props.disabled - Determines whether the button should be disabled.
 * @param {(duration: number) => void} props.onClick - The function to call when the button is clicked, passing the selected duration as an argument.
 * @returns {React.ReactNode} The pause button component.
 */
const PauseForDurationButton = (props) => {
  const { duration, loading, disabled, onClick } = props;
  return (
    <button
      type="button"
      className="btn-green text-white px-3 py-1"
      onClick={() => onClick(duration)}
      disabled={disabled}
    >
      <p>{loading ? "Updating..." : `${duration} days`}</p>
    </button>
  );
};
/**
 * @param {{ email: string }} props - (Required) The email associated with the subscription.
 * @returns {React.ReactNode}
 */
const PauseBoostSubscriptionModal = (props) => {
  const { email, closeModal } = props;
  const [pauseSubscription, { loading, error }] = useMutation(
    PAUSE_BOOST_SUBSCRIPTION,
    { refetchQueries: [{ query: BOOST_DATA_QUERY, variables: { email } }] },
  );
  const [selectedDuration, setSelectedDuration] = useState(null);

  const errorMessage =
    error?.graphQLErrors?.length > 0 ? error.graphQLErrors[0].message : "";

  const _pauseSubscription = async (duration) => {
    setSelectedDuration(duration);
    try {
      await pauseSubscription({ variables: { email, duration } });
      closeModal();
    } catch (e) {
      // ignore
    } finally {
      setSelectedDuration(null);
    }
  };

  return (
    <div
      style={{ backgroundColor: "#FAFAFA", minWidth: 400 }}
      className="py-8 px-12 flex flex-col items-center max-w-2xl"
    >
      <h1>Choose duration:</h1>
      <div className="flex flex-row align-center mt-4">
        <PauseForDurationButton
          duration={30}
          loading={loading && selectedDuration === 30}
          disabled={loading}
          onClick={_pauseSubscription}
        />
        <div className="ml-4">
          <PauseForDurationButton
            duration={60}
            loading={loading && selectedDuration === 60}
            disabled={loading}
            onClick={_pauseSubscription}
          />
        </div>
      </div>
      <p className="mt-1 text-red-500">{errorMessage}</p>
    </div>
  );
};

export default PauseBoostSubscriptionModal;
